export default __webpack_public_path__ + "static/media/LinkedIn.94e38961.svg";